import vtc from "../../assets/images/vtc.svg";
import vtc2 from "../../assets/images/vtc2.svg";
import vtv3 from "../../assets/images/vtv3.svg";
import vtc6 from "../../assets/images/vtc6.svg";
import vinh_phu from "../../assets/images/vinh_phu.svg";

export default function Cooperate() {
  const slides = [
    { src: vinh_phu, alt: "vp" },
    { src: vtc2, alt: "vtc2" },
    { src: vtc6, alt: "vtc6" },
    { src: vtv3, alt: "vtv3" },
    { src: vtc, alt: "vtc" },
  ];
  return (
    <div className="w-full bg-white">
      <div className="container mx-auto p-3 mt-14">
        <div className="w-full flex flex-col gap-2 lg:flex-col lg:gap-2 lg:items-center lg:justify-center">
          <div className="w-full flex items-center gap-2 lg:flex lg:items-center lg:justify-center">
            <div>
              <p className="text-[#033F6A] text-[18px] font-semibold">
                Khách hàng & đối tác của
              </p>
            </div>
            <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
              <p className="text-[1.125rem] font-semibold text-white">
                BlueSkyIT
              </p>
            </div>
          </div>
          <div>
            <p className="text-[24px] lg:text-[36px] text-[#1375B7] font-semibold">
              Một số đối tác nổi bật của chúng tôi
            </p>
          </div>
        </div>
        <div>
          <div className="hidden md:block lg:block w-full mt-4">
            <div className="flex w-full items-center gap-3">
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vinh_phu} alt="vp" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc2} alt="vtc2" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc6} alt="vtc6" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtv3} alt="vtv3" />
              </div>
              <div className="w-1/5 h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc} alt="vtc" />
              </div>
            </div>
          </div>
          <div className="block md:hidden lg:hidden">
            <div className="grid grid-cols-2 w-full gap-2">
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vinh_phu} alt="vp" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc2} alt="vtc2" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc6} alt="vtc6" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtv3} alt="vtv3" />
              </div>
              <div className="w-full h-[78px] px-[16px] py-[16px] rounded-[8px] bg-white shadow-custom flex items-center justify-center border border-solid border-[#E2E2E2]">
                <img src={vtc} alt="vtc" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
